import React from 'react'

function Reservation() {
  return (
    <section id='reservasi' className='background-black'>
      <div className="container">
        <div className="row text-light">
          <div className="col-12 col-md-6">
            <h2 className='mb-4 color-secondary'>Syarat & Ketentuan</h2>
            <h4 className='text-decoration-underline mb-4'>RESERVATION</h4>
            <p className='m-0'>Dalam Perjanjian Sewa, Penyewa adalah orang yang menyewa Kendaraan yang ditentukan dalam Perjanjian (selanjutnya disebut Kendaraan) dari Perusahaan Rental Black Canyon Transport</p>
            <p className='color-black m-0'>Rental mobil palu, Rental mobil di kota palu, Rental mobil Kota Palu, Rental mobil murah kota palu, Sewa mobil di kota palu, Sewa mobil palu, Black Canyon Transport</p>
          </div>
          <div className="col-12 col-md-6" data-aos="zoom-out" data-aos-duration="1500">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Durasi
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    Sewa mobil dengan jasa sopir di hitung selama 12 jam per hari. Kelebihan waktu (over time) akan di kenakan biaya sebesar 10% dari harga sewa kendaraan per hari atau sesuai dengan biaya extra time.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Pembatalan
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    Pembatalan sewa kendaraan dapat dilakukan paling lambat selama 2×24 Jam sebelum jatuh hari sewa. Pembatalan sewa kendaraan 2×24 jam
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Down Payment (DP)
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    Down Payment 30% dari total pembayaran sebagai tanda jadi booking dan keep armada
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Konfirmasi
                  </button>
                </h2>
                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    Jika anda mengirim uang melalui Bank, cukup info kepada kami via SMS, email, telpon atau Whatsapp, kemudian kami akan mengirimkan invoice atau bukti pembayaran ke alamat email atau whatsapp.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Reservation